// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__GB9Rx","loader-bar":"Loader_loader-bar__9uogW","progressAnimation":"Loader_progressAnimation__jWi9e"};